// ExpandToggle.jsx
import React from 'react';
import { HiMiniArrowsPointingIn, HiMiniArrowsPointingOut } from 'react-icons/hi2';
import { useMap } from '../contexts/ClustererContext'; // 👈 importa o contexto

const ExpandToggle = ({ className = '', size = 'md' }) => {
    const { showClusterer, toggleClusterer } = useMap(); // 👈 vem do contexto

    const sizeStyles = {
        sm: { width: '2.5rem', height: '1.25rem', circle: '1rem', icon: '0.55rem' },
        md: { width: '3rem', height: '1.5rem', circle: '1.25rem', icon: '0.75rem' },
        lg: { width: '3.5rem', height: '1.8rem', circle: '1.5rem', icon: '1rem' },
        xl: { width: '4.1rem', height: '2.1rem', circle: '1.75rem', icon: '1.1rem' }
    };

    const currentSize = sizeStyles[size] || sizeStyles.md;

    return (
        <button
            onClick={toggleClusterer} // 👈 dispara ação global
            className={className}
            style={{
                marginTop: 0,
                width: currentSize.width,
                height: currentSize.height,
                borderRadius: '9999px',
                backgroundColor: showClusterer ? '#202727' : '#FFFFFF',
                border: '1px solid var(--border-secondary)',
                position: 'relative',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
            }}
            aria-label={`Alternar para ${showClusterer ? 'fechado' : 'expandido'}`}
            title={`Alternar para ${showClusterer ? 'fechado' : 'expandido'}`}
        >
            {/* Ícone de Expandir (lado esquerdo) */}
            <span
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '8px',
                    transform: 'translateY(-50%)',
                    fontSize: currentSize.icon,
                    color: showClusterer ? '#fff' : '#000000',
                    transition: 'all 0.3s ease'
                }}
            >
                <HiMiniArrowsPointingOut />
            </span>

            {/* Ícone de Recolher (lado direito) */}
            <span
                style={{
                    position: 'absolute',
                    top: '50%',
                    right: '8px',
                    transform: 'translateY(-50%)',
                    fontSize: currentSize.icon,
                    color: showClusterer ? '#fff' : '#000',
                    transition: 'all 0.3s ease'
                }}
            >
                <HiMiniArrowsPointingIn />
            </span>

            {/* Bola que se move */}
            <span
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: showClusterer
                        ? `calc(100% - ${currentSize.circle} - 2px)`
                        : '2px',
                    transform: 'translateY(-50%)',
                    width: currentSize.circle,
                    height: currentSize.circle,
                    borderRadius: '50%',
                    backgroundColor: !showClusterer ? '#000000' : '#FFFFFF',
                    transition: 'all 0.3s ease'
                }}
            ></span>
        </button>
    );
};

export default ExpandToggle;
